import { createNavigation } from 'next-intl/navigation'
import { defineRouting } from 'next-intl/routing'
import { getLocale } from 'next-intl/server'

import { DEFAULT_LOCALE } from '@/constants'
import { env } from '@/utils'

const langCookieDomain = env.HOST?.replace(/^.*:\/\//g, '').replace(
	/:\d+$/g,
	'',
)

const localeCookie = {
	name: 'lang',
	domain: langCookieDomain,
	maxAge: 315360000,
	path: '/',
}

export const nextIntlRouting = defineRouting({
	locales: env.LOCALE_LIST,
	defaultLocale: DEFAULT_LOCALE,
	localePrefix: 'as-needed',
	localeCookie,
	localeDetection: false,
})

export const setLocaleCookieClient = (locale: string) => {
	document.cookie = [
		`${localeCookie.name}=${locale}`,
		`path=${localeCookie.path}`,
		`max-age=${localeCookie.maxAge}`,
		localeCookie.domain && `domain=${localeCookie.domain}`,
		'SameSite=Lax',
	]
		.filter(Boolean)
		.join('; ')
}

export const {
	Link: IntlLink,
	redirect,
	usePathname,
	useRouter,
	getPathname,
} = createNavigation(nextIntlRouting)

type TRedirectPropsWithoutLocale = Omit<
	Parameters<typeof redirect>[0],
	'locale'
>

export type TRouter = ReturnType<typeof useRouter>

export const redirectWithCurrentLocale = async (
	props: TRedirectPropsWithoutLocale,
) => {
	redirect({ ...props, locale: await getLocale() })
}

export const redirectWithUserLocale = async (
	props: TRedirectPropsWithoutLocale,
	userLanguage?: string,
) => {
	const locale =
		userLanguage && env.LOCALE_LIST.includes(userLanguage)
			? userLanguage
			: await getLocale()
	redirect({ ...props, locale })
}
